/* tslint:disable */
/* eslint-disable */
/**
 * Vipps ePayment Internal API
 * The Vipps ePayment Internal api
 *
 * The version of the OpenAPI document: 0.9.0
 * Contact: teamecom@vipps.no
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Merchant,
    MerchantFromJSON,
    MerchantFromJSONTyped,
    MerchantToJSON,
} from './Merchant';
import {
    Transaction,
    TransactionFromJSON,
    TransactionFromJSONTyped,
    TransactionToJSON,
} from './Transaction';

/**
 * 
 * @export
 * @interface CardPagePaymentResult
 */
export interface CardPagePaymentResult {
    /**
     * 
     * @type {Merchant}
     * @memberof CardPagePaymentResult
     */
    merchant: Merchant;
    /**
     * 
     * @type {Transaction}
     * @memberof CardPagePaymentResult
     */
    transaction: Transaction;
    /**
     * 
     * @type {number}
     * @memberof CardPagePaymentResult
     */
    expireTime: number;
    /**
     * 
     * @type {string}
     * @memberof CardPagePaymentResult
     */
    peToken: string;
}

export function CardPagePaymentResultFromJSON(json: any): CardPagePaymentResult {
    return CardPagePaymentResultFromJSONTyped(json, false);
}

export function CardPagePaymentResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): CardPagePaymentResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'merchant': MerchantFromJSON(json['merchant']),
        'transaction': TransactionFromJSON(json['transaction']),
        'expireTime': json['expireTime'],
        'peToken': json['peToken'],
    };
}

export function CardPagePaymentResultToJSON(value?: CardPagePaymentResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'merchant': MerchantToJSON(value.merchant),
        'transaction': TransactionToJSON(value.transaction),
        'expireTime': value.expireTime,
        'peToken': value.peToken,
    };
}

